import { useEffect } from 'react';

const useMultipleOutsideClick = ({ refs, conditions, callback }) => {
	useEffect(() => {
		const handleClickOutside = (event) => {
			refs.forEach((ref, index) => {
				if (ref.current && !ref.current.contains(event.target) && conditions[index]) {
					callback();
				}
			});
		};

		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [refs, conditions, callback]);
};

export default useMultipleOutsideClick;
